import { PureComponent, ReactNode } from 'react';
import ReactHotkeys from 'react-hot-keys';
import { GeniePadElementsSettingItem, MedicalHistoryConfig } from '../../../../../api/pushGenie';
import RightPopUp from '../../../../common/RightPopUp';
import ElementsConfigureTable from './ElementsConfigureTable';
import { Tabs } from 'antd';
import PatientConfig from './PatientConfig';
import NewPatientMHConfig from './NewPatientMHConfig';
import { track } from '../../../../../tracking';

export type ConfigTabs = 'Patient' | 'Medical History';

interface Props<T> {
    title: string;
    configTableTitle: string;
    closeMe: () => void;
    onUpdate: (config: T[]) => void;
    config: T[];
    defaultSelectedTab?: ConfigTabs;
    configureTabs?: ConfigTabs[];
    updateShowMedicalHistory?: (val: boolean) => void;
    onRefresh: () => void;
}

type State<T> = {
    elements: T[];
    selectedTab: ConfigTabs;
};

class CongigureElemtsTableDialog<T extends GeniePadElementsSettingItem> extends PureComponent<
    Props<T>,
    State<T>
> {
    state: State<T> = {
        elements: this.props.config,
        selectedTab: this.props.defaultSelectedTab ?? 'Patient',
    };
    onSave = (): void => {
        track('ADD_PATIENT_CONFIGURE', { from: 'Patient Tab' });

        const { closeMe, onUpdate } = this.props;
        const { elements } = this.state;
        onUpdate(elements);
        closeMe();
    };

    updateElemets = (elements: T[]): void => {
        this.setState({ elements });
    };

    componentDidUpdate = (prevProps: Props<T>): void => {
        if (prevProps.config !== this.props.config) {
            this.setState({ elements: this.props.config });
        }
    };

    renderConfigConmponent = () => {
        const currTab = this.state.selectedTab;

        const { elements } = this.state;
        const { configTableTitle, closeMe, updateShowMedicalHistory, onRefresh } = this.props;

        let configComponent: ReactNode;

        switch (currTab) {
            case 'Patient':
                configComponent = (
                    <PatientConfig
                        closeMe={closeMe}
                        configTableTitle={configTableTitle}
                        elements={elements}
                        onSave={this.onSave}
                        updateElemets={this.updateElemets}
                    />
                );
                break;
            case 'Medical History':
                configComponent = <NewPatientMHConfig closeMe={closeMe} onRefresh={onRefresh} />;
                break;

            default:
                break;
        }

        return configComponent;
    };

    setSelectedTab = (tab: ConfigTabs): void => {
        this.setState({ selectedTab: tab });
    };

    render(): ReactNode {
        const { closeMe, title, configureTabs } = this.props;
        const { selectedTab } = this.state;

        return (
            <ReactHotkeys keyName="esc" onKeyDown={closeMe}>
                <RightPopUp closeMe={closeMe} width={'70%'} minWidth={'480px'}>
                    <div className="bg-darwin-neutral-50 flex flex-col h-full space-between">
                        <div className="flex flex-col gap-8 items-start bg-white cursor-pointer">
                            <div
                                className={`flex items-center gap-8 mx-24 ${
                                    configureTabs ? 'mt-16' : 'm-16'
                                }`}
                            >
                                <div
                                    onClick={closeMe}
                                    className="flex items-center justify-center w-16 h-16"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 448 512"
                                        className="w-16 h-16 fill-darwin-neutral-1000"
                                    >
                                        <path d="M447.1 256c0 13.25-10.76 24.01-24.01 24.01H83.9l132.7 126.6c9.625 9.156 9.969 24.41 .8125 33.94c-9.156 9.594-24.34 9.938-33.94 .8125l-176-168C2.695 268.9 .0078 262.6 .0078 256S2.695 243.2 7.445 238.6l176-168C193 61.51 208.2 61.85 217.4 71.45c9.156 9.5 8.812 24.75-.8125 33.94l-132.7 126.6h340.1C437.2 232 447.1 242.8 447.1 256z"></path>
                                    </svg>
                                </div>
                                <p className="text-darwin-neutral-1000 heading-2 bold">{title}</p>
                            </div>
                            {configureTabs && (
                                <div className="flex items-center gap-8 mx-24 mt-12">
                                    {configureTabs.map((tab) => (
                                        <div
                                            className={`${
                                                tab === selectedTab
                                                    ? 'bg-darwin-neutral-50'
                                                    : 'bg-white'
                                            } px-24 py-4 rounded-t-8`}
                                            onClick={() => this.setSelectedTab(tab)}
                                        >
                                            <span
                                                className={`${
                                                    tab === selectedTab
                                                        ? 'text-darwin-accent-bright-blue-800'
                                                        : 'text-darwin-neutral_new-1000'
                                                } font-700 text-14`}
                                            >
                                                {tab}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        {this.renderConfigConmponent()}
                    </div>
                </RightPopUp>
            </ReactHotkeys>
        );
    }
}

export default CongigureElemtsTableDialog;
